import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/chevron_right.svg';


export default (props: SVGProps<any>) => <ReactComponent {...props} />;
